import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import "./PraneshInstagramSlider.css";
import { FaPlay } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const PraneshInstagramSlider = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "ta";

  const [cards, setCards] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(5);

  const instagramLink = "https://www.instagram.com/cm_pranesh_official/";
const BASE_URL = "https://admin.cmpranesh-admk.com";

  // =========================
  // Fetch Instagram Images
  // =========================
useEffect(() => {
  axios
    .get("https://admin.cmpranesh-admk.com/api/getInstagram.php")
    .then((res) => {
      setCards(res.data);
    })
    .catch((err) => {
      console.error("Instagram fetch error:", err);
    });
}, []);


  // =========================
  // Responsive slide count
  // =========================
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 767) {
        setSlidesToShow(2);        // Mobile
      } else if (width <= 1023) {
        setSlidesToShow(3);        // Tablet
      } else {
        setSlidesToShow(5);        // Desktop
      }
    };

    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
  appendDots: (dots) => (
    <ul style={{ margin: "0px" }}>
      {dots.filter((dot, index) => index % 3 === 0)} {/* show every 2nd dot */}
    </ul>
  ),
};


  return (
    <div className="cm-pranesh-leader-instagram-wrapper">

      <h2 className="cm-pranesh-leader-instagram-title">
        {lang === "ta"
          ? "எங்கள் இன்ஸ்டாகிராம் புதுப்பிப்புகள்"
          : "Our Instagram Updates"}
      </h2>

      <Slider {...settings} className="cm-pranesh-leader-instagram-slider">
        {cards.map((image, index) => (
          <div key={index} className="cm-pranesh-leader-instagram-card">
            <a
              href={instagramLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="cm-pranesh-leader-instagram-imgbox">
                <img
                  src={`${BASE_URL}/${image}`}
                  alt="instagram-post"
                />
                <div className="cm-pranesh-leader-instagram-play">
                  <FaPlay />
                </div>
              </div>
            </a>
          </div>
        ))}
      </Slider>

      <div className="cm-pranesh-leader-instagram-follow-box">
        <p className="cm-pranesh-leader-instagram-id">
          @cm_pranesh_official
        </p>
        <a
          href={instagramLink}
          target="_blank"
          rel="noopener noreferrer"
          className="cm-pranesh-leader-instagram-follow-btn"
        >
          {lang === "ta"
            ? "இன்ஸ்டாகிராமில் பின்தொடரவும்"
            : "Follow on Instagram"}
        </a>
      </div>

    </div>
  );
};

export default PraneshInstagramSlider;
